  <header-web (dataEvent)='setLanguage($event)'></header-web>
  <div class="container text-center my-4 px-5">
    <h2 class="color-1 title fw-bold text-rojo">¡AYUDAMOS EN TU AGENCIA!</h2>
    <div class="row">
      <div class="col-8 offset-2">
        <div class="container">
          <p class="subtitle mt-4 mb-1 text-justify font-weight-bold"><span class="color-1">GALILEO ERP</span> es un software en
            la nube que facilita la gestión de sus reservas y pagos online, está totalmente adaptado a la normativa de
            tributación peruana, podrá generar comprobantes grabados y de exportación de servicios.</p>
          <p class="subtitle text-center font-weight-bold pt-md-1 pt-4">El uso del software se complementa con el motor de
            reservas online integrado a su página web, a través del cual podrá recibir reservas y pagos por medio de la
            plataforma niubiz de visanet.</p>
        </div>
      </div>
    </div>
  </div>
  <section class="container-fluid px-5">
    <div class="row d-flex align-items-center">
      <div class="col-md-6 col-12 p-md-5 py-2 px-5">
        <h3 class="text-center font-weight-bold p-4 title color-1">RESERVAS</h3>
        <hr class="linea-2">
        <p class="text fw-bold">La solución <b class="color-1">facilita la gestión</b> completa de reservas de circuitos turísticos,
          excursiones, etc. Todos los procesos están integrados, soportados y automatizados..</p>
      </div>
      <div class="col-md-6 col-12 text-center p-3">
        <img src="img/turismo-1.jpg" class="img-fluid" alt="">
      </div>
    </div>
    <div class="row align-items-center" style="background-color: #DCFEF6">
      <div class="col-md-6 col-12 text-center p-3 order-md-1 order-2">
        <img src="img/turismo-3.jpg" class="img-fluid" alt="">
      </div>
      <div class="col-md-6 col-12 p-5 order-md-2 order-1">
        <h3 class="text-center font-weight-bold p-4 titulo text-dark">FACTURACION</h3>
        <hr class="linea-2">
        <p>Permite la emisión y validación de facturas. Además, el software gestiona
          cobros y pagos y está integrado con diferentes pasarelas de pago.
        </p>
      </div>
    </div>
    <div class="row align-items-center" style="background-color: #D3D3D3">
      <div class="col-md-6 col-12 p-5">
        <h3 class="text-center font-weight-bold p-4 color-1 titulo">WEB</h3>
        <hr class="linea-2">
        <p><b class="color-1">GALILEO ERP </b>ofrece una variedad de plantillas o modelos que se adapten más a su negocio.
          Podrá integrar una pasarela de pagos online, para gestionar sus reservas y pagos
        </p>
      </div>
      <div class="col-md-6 col-12 text-center p-3">
        <img src="img/turismo-2.jpg" class="img-fluid" alt="">
      </div>
    </div>
  </section>
  <div class="row">
    <div class="col-md-8 offset-md-2 col-12">
      <div class="container my-5">
        <h1 class="text-center title text-lago">NUESTRAS VENTAJAS PARA TU AGENCIA</h1>
        <div class="row mt-5">
          <div class="col-6">
            <div class="card border-0 mb-3">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-3">
                  <img src="../../assets/image/recursos/globo-2.png" class="card-img" alt="...">
                </div>
                <div class="col-md-9 px-0">
                  <div class="card-body d-none d-md-block">
                    <p class="card-text text-start text-rojo subtitle lh-1">Automatiza y agiliza la gestión completa de reservas</p>
                  </div>
                  <div class="card-body px-0 d-block d-md-none">
                    <p class="card-text color-1 subtitle">Automatiza y agiliza la gestión completa de reservas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card border-0 mb-3">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-3">
                  <img src="../../assets/image/recursos/globo-4.png" class="card-img" alt="...">
                </div>
                <div class="col-md-9">
                  <div class="card-body d-none d-md-block">
                    <p class="card-text text-start text-rojo subtitle lh-1">Personalizable y abierto para adaptarlo a tus propios
                      procesos de negocio</p>
                  </div>
                  <div class="card-body px-0 d-block d-md-none">
                    <p class="card-text color-1 text">Personalizable y abierto para adaptarlo a tus propios
                      procesos de negocio</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card border-0 mb-3">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-3">
                  <img src="../../assets/image/recursos/globo-3.png" class="card-img" alt="...">
                </div>
                <div class="col-md-9">
                  <div class="card-body d-none d-md-block">
                    <p class="card-text text-rojo subtitle lh-1">Solución multiplataforma, accesible cuando quieras y
                      desde donde quieras</p>
                  </div>
                  <div class="card-body d-block d-md-none px-0">
                    <p class="card-text text-center color-1 text">Solución multiplataforma, accesible cuando quieras y
                      desde donde quieras</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card border-0 mb-3">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-3">
                  <img src="../../assets/image/recursos/globo-1.png" class="card-img" alt="...">
                </div>
                <div class="col-md-9">
                  <div class="card-body d-none d-md-block">
                    <p class="card-text text-start text-rojo subtitle lh-1">Reduce costes operativos y aumenta la productividad</p>
                  </div>
                  <div class="card-body d-block d-md-none px-0">
                    <p class="card-text text-center color-1 text">Reduce costes operativos y aumenta la productividad
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer-web class="mt-5"></footer-web>
